import React, { useRef } from 'react';
import { Components } from './styled';
import ProjectModal from '../../ProjectModal';
import { LARGE_PROJECT_MODAL_WIDTH } from '../../../utils/styled/dimensions';

const ChangelogModal = ({
  isModalOpen,
  onModalClose,
  changelog,
}: {
  isModalOpen: boolean;
  onModalClose: () => void;
  changelog: any;
}) => {
  return (
    <ProjectModal
      modalTitle={'Release notes'}
      bodyChildren={<ModalBody changelog={changelog} />}
      isModalOpen={isModalOpen}
      modalWidth={LARGE_PROJECT_MODAL_WIDTH}
      onModalClose={onModalClose}
      buttonChildren={<ModalButton onDismiss={onModalClose} />}
    />
  );
};

export default ChangelogModal;

const ModalBody = ({ changelog }: { changelog: any }) => {
  const data = useRef(changelog?.versions || []).current;
  return (
    <Components.Container>
      {data.map((item: any, index: number) => {
        return (
          <Components.Item key={index}>
            <Components.ItemTitle>v{item.version}</Components.ItemTitle>
            <Components.List>
              {item.description.map((description: string, index: number) => {
                return (
                  <Components.ListItem key={index}>
                    <Components.ItemDescription key={index}>{description}</Components.ItemDescription>
                  </Components.ListItem>
                );
              })}
            </Components.List>
          </Components.Item>
        );
      })}
    </Components.Container>
  );
};

const ModalButton = ({ onDismiss }: { onDismiss: () => void }) => {
  return (
    <Components.Button onClick={onDismiss}>
      <Components.ButtonText>{'Dismiss'}</Components.ButtonText>
    </Components.Button>
  );
};
